const locale: Locale = {
  ko: {
    mine: '나의 청원',
  },
  en: {
    mine: 'My Petitions',
  },
}

export default locale
